import {getFeatureSettings} from './getFeatureSettings'
import {fetchFeatures} from './fetchFeatures'
import {listPersonTargetFeatures} from './listPersonTargetFeatures'
import {createPersonTargetFeature} from './createPersonTargetFeature'
import {deletePersonTargetFeature} from './deletePersonTargetFeature'

export const featureSettings = {
  getFeatureSettings,
  fetchFeatures,
  listPersonTargetFeatures,
  createPersonTargetFeature,
  deletePersonTargetFeature,
}

export type {PersonTargetFeatureRow} from './listPersonTargetFeatures'
